<div class="about-container">
  <app-navbar></app-navbar>

  <div class="overlay">
    <div class="holder">
      <div class="btn">
        <button class="btn-agent">About Us</button>
      </div>
      <div class="title">
        <h2>A new era of payment evolution in Africa</h2>
        <p>
          A flexible, modern and secure payment collection platform in Nigeria
        </p>
      </div>
    </div>
  </div>

  <!-- what we do-->
  <div class="who-we-are">
    <div class="wwa-left" data-aos="fade-up-left" data-aos-duration="2000">
      <div class="wwd-button">
        <button class="btn-wwd">Who We Are</button>
      </div>
      <div class="wwd-title">
        <h2>
          A flexible payment solution that supports every stage of your growth.
        </h2>
      </div>
      <div class="wwd-text">
        <h3>
          HuiosPay was born out of a desire to streamline online and offline
          payment services closely, allied with the emphasis on excellent
          customer services, provided by direct partnerships with world class
          platform providers.
          <br /><br />
          With HuiosPay platform, you can:
        </h3>
      </div>
      <div class="wwd-bulletin">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Pay Electricity Bills.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Send Invoice.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Mobile Phone Topups.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Buy Items.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Internet Subscription.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Securely Receive Payments.</p>
            </div>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Cable TV Subscription.</p>
            </div>
          </div>
          <div class="list1">
            <div class="icon">
              <img src="../../../../assets/img/bulleton.svg" alt="icon" />
            </div>
            <div class="text">
              <p>Payment Gateway.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="wwa-right" data-aos="fade-up-right" data-aos-duration="2000">
      <img src="../../../../assets/img/phoneKey.png" alt="terminal" />
    </div>
  </div>
  <!-- end of what we do-->

  <!-- why us section -->
  <div class="why-us">
    <div class="wu-left" data-aos="fade-up-left" data-aos-duration="2000">
      <img src="../../../../assets/img/why.png" alt="why us" />
    </div>

    <div class="wu-right" data-aos="fade-up-right" data-aos-duration="2000">
      <div class="wu-btn">
        <button class="btn-wwd">Why Us ?</button>
      </div>
      <div class="wu-title">
        <h3>Find out why we are the preferred payment platform in Africa!</h3>
      </div>
      <div class="wu-card">
        <div class="icon">
          <img src="../../../../assets/img/why1.png" alt="why-us" />
        </div>
        <div class="right">
          <div class="title">
            <h3>Security</h3>
          </div>
          <div class="text">
            <h4>
              Our platform is designed to provide end-to-end protection against
              fraud and suspicious activities>
            </h4>
          </div>
        </div>
      </div>
      <div class="wu-card">
        <div class="icon">
          <img src="../../../../assets/img/why2.png" alt="why-us" />
        </div>
        <div class="right">
          <div class="title">
            <h3>Fast Settlement</h3>
          </div>
          <div class="text">
            <h4>
              We ensure the fastest remittance window to your approved account
              within 24 hours.
            </h4>
          </div>
        </div>
      </div>
      <div class="wu-card">
        <div class="icon">
          <img src="../../../../assets/img/why3.png" alt="why-us" />
        </div>
        <div class="right">
          <div class="title">
            <h3>Dispute Resolution</h3>
          </div>
          <div class="text">
            <h4>
              Claims and disputes are resolved within the shortest possible
              time.
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- End of Why us Section -->

  <!-- people we serve-->
  <div class="who-we-are">
    <div class="wwa-left" data-aos="fade-up-left" data-aos-duration="2000">
      <div class="wwd-title">
        <h2>The people we serve?</h2>
      </div>
      <div class="wwd-text">
        <h3>
          At HuiosPay, our focus is to provide and deliver excellent services
          making sure that merchants and customers are happy when making
          payments via our platforms and channels. That means customers can make
          payments and top-up with ease across all our terminals.
        </h3>
      </div>
      <div class="pws-dropdown">
        <div class="list">
          <div class="list1">
            <div class="icon">
              <app-font-icon
                iconType="remix"
                iconName="arrow-down-s-line"
                iconSize="custom"
                iconColor="#000"
              >
              </app-font-icon>
            </div>
            <div class="title">
              <h3>For Entrepreneurs</h3>
            </div>
          </div>
          <div class="text">
            <p>
              HuiosPay provides a flexible payment platform uniquely suited to
              simplify the process of transactions and is tailored to a variety
              of industries and business models. With a continued focus on
              excellent service, the goal remains to ensure maximum user
              satisfaction when conducting transactions via our payment
              platforms and channels.
            </p>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <app-font-icon
                iconType="remix"
                iconName="arrow-down-s-line"
                iconSize="custom"
                iconColor="#000"
              >
              </app-font-icon>
            </div>
            <div class="title">
              <h3>For Corporations</h3>
            </div>
          </div>
          <div class="text">
            <p>
              HuiosPay is determined to remain synonymous with excellent
              customer service, with user satisfaction remaining a priority when
              utilizing our channels and terminals. Our unique blend of
              innovation and market leading technology with the warmth of
              traditional hospitality ensures that clients can rely on strict
              adherence to relevant security and safety protocols, a streamlined
              users interface as well as guaranteed customer experience.
            </p>
          </div>
        </div>
        <div class="list">
          <div class="list1">
            <div class="icon">
              <app-font-icon
                iconType="remix"
                iconName="arrow-down-s-line"
                iconSize="custom"
                iconColor="#000"
              >
              </app-font-icon>
            </div>
            <div class="title">
              <h3>For Individuals</h3>
            </div>
          </div>
          <div class="text">
            <p>
              We provide a flexible means of transactions tailored to solve
              individual needs. With a continued focus on excellent service, the
              goal remains to ensure maximum user satisfaction when conducting
              transactions via our payment platforms and channels.
            </p>
          </div>
        </div>
      </div>
      <div class="btn">
        <button class="btn-agent2">
          <a
            href="/become-merchant"
            style="text-decoration: none; color: inherit"
            >Start Transacting</a
          >
        </button>
      </div>
    </div>
    <div class="wwa-right" data-aos="fade-up-right" data-aos-duration="2000">
      <img src="../../../../assets/img/pws.png" alt="terminal" />
    </div>
  </div>
  <!-- end of people we serve-->

  <!-- Community section-->
  <!-- <app-community-section></app-community-section> -->
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->
</div>

<app-back-to-top
  [acceleration]="2"
  [animate]="true"
  [scrollDistance]="50"
  [speed]="50"
>
</app-back-to-top>
